export default "__VITE_ASSET__KxcbB4db__";